'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  label: {
    fontFamily: 'Helvetica Neue',
    fontSize: '16px',
    color: '#4a494b',
    display: 'inline-block',
    '@media (max-width: 767px)': {
      display: 'block'
    }
  },
  errorLabel: {
    marginLeft: '5px',
    fontSize: '12px',
    '@media (max-width: 767px)': {
      marginLeft: 0,
      marginTop: '5px'
    }
  },
  input: {
    marginTop: '14px',
    border: '2px solid #ddd',
    fontSize: '16px',
    color: '#4a494b',
    fontFamily: 'Helvetica Neue',
    padding: '8px',
    boxSizing: 'border-box',
    ':focus': {
      outline: 0
    }
  }
};

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Input, [{
    key: 'dimension',
    value: function dimension() {
      return {
        width: this.props.width || 'auto',
        height: this.props.height || '30px'
      };
    }
  }, {
    key: 'error',
    value: function error() {
      if (this.props.error) {
        return {
          color: 'red'
        };
      } else {
        return {
          color: '#4a494b'
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Element = this.props.type === 'textarea' ? 'textarea' : 'input';

      var valueError = function valueError() {
        var valueErrorMesage = '';

        if (_this2.props.error) {
          if (_this2.props.className === 'email') {
            valueErrorMesage = '(Please enter a correct email address)';
          } else if (_this2.props.className === 'phoneNumber') {
            valueErrorMesage = '(Please enter a valid phone number)';
          } else if (_this2.props.className === 'companyWebsite') {
            valueErrorMesage = '(Please enter a valid website)';
          }

          return _react2["default"].createElement('div', {
            style: [styles.label, _this2.error(), styles.errorLabel]
          }, valueErrorMesage);
        }

        return null;
      };

      return _react2["default"].createElement('div', {
        style: this.props.wrapperStyle
      }, _react2["default"].createElement('div', {
        style: [styles.label, this.error()]
      }, this.props.name), valueError(), _react2["default"].createElement(Element, {
        value: this.props.value,
        placeholder: this.props.placeholder || '',
        type: this.props.type || 'text',
        style: [styles.input, this.dimension()],
        onChange: this.props.onChange,
        onBlur: this.props.onBlur,
        className: this.props.className,
        'aria-label': this.props.name,
        'data-field-name': this.props.fieldName
      }));
    }
  }]);

  return Input;
}(_react2["default"].Component);

var component = (0, _radium2["default"])(Input);
exports["default"] = {
  component: component
};